import CustomDivider from '../../shared/utils/CustomDivider'
import DailyReports from './Reports/DailyReports'
import FieldReports from './Reports/FieldReports'
import OnBoardingReports from './Reports/OnBoardingReports'
import SalesReports from './Reports/SalesReports'
import ZoneReports from './Reports/ZoneReports'

const AdminReport = () => {


    return (
        <>
            <DailyReports />
            <CustomDivider />
            <SalesReports />
            <CustomDivider />
            <FieldReports />
            <CustomDivider />
            <ZoneReports />
            <CustomDivider />
            <OnBoardingReports />
        </>
    )
}

export default AdminReport